"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _toConsumableArray2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _banner = _interopRequireDefault(require("@/components/banner.vue"));
var _search = _interopRequireDefault(require("@/components/search.vue"));
var _menus = _interopRequireDefault(require("@/components/menus.vue"));
var _nav = _interopRequireDefault(require("@/components/nav.vue"));
var _courseItemResource = _interopRequireDefault(require("@/components/courseItemResource.vue"));
require("../index.less");
var _public = require("@/api/public/public");
var _beforeMen = require("@/api/beforeMen/beforeMen");
var _index2 = require("@/api/virtualSimulationClass/index");
var _projectLevel = require("@/utils/projectLevel");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Banner: _banner.default,
    Search: _search.default,
    Nav: _nav.default,
    Menus: _menus.default,
    CourseResource: _courseItemResource.default
  },
  data: function data() {
    return {
      imgBanner: require("../../../assets/img/image/topbg.png"),
      tabList: this.$store.getters.wProfessionalResourceLibraryType,
      curIndex: 0,
      menusList: [],
      menusList1: [{
        tit: '产业分类',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(this.$store.getters.wIndustryType)),
        actheight: false,
        act: 0,
        isZhan: false
      }, {
        tit: '行业门类',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(this.$store.getters.wIndustryCategory)),
        actheight: false,
        act: 0,
        isZhan: true
      }, {
        tit: '级别',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(_projectLevel.projectLevelOptions)),
        actheight: false,
        act: 0,
        isZhan: false
      }
      //  {
      //   tit:'类型',
      //   itemList:[{ "id": "1", "name": "专业资源库", "sort": 3, "provinceId": "506e5e697931475fa8c481ad97a3816d", "remark": null, "isDelete": 0, "value": "1" },
      //             { "id": "2", "name": "专业群资源库",  "sort": 2, "provinceId": "506e5e697931475fa8c481ad97a3816d", "remark": null, "isDelete": 0, "value": "2" }, ],
      //   actheight:false,
      //   act:0,
      //   isZhan:false,
      // },
      // {
      //   tit:'类型',
      //   itemList:[...this.$store.getters.wResourceType],
      //   actheight:false,
      //   act:0,
      //   isZhan:false,
      // },
      ],
      menusList2: [{
        tit: '产业分类',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(this.$store.getters.wIndustryType)),
        actheight: false,
        act: 0,
        isZhan: false
      }, {
        tit: '行业门类',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(this.$store.getters.wIndustryCategory)),
        actheight: false,
        act: 0,
        isZhan: true
      }, {
        tit: '级别',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(_projectLevel.projectLevelOptions)),
        actheight: false,
        act: 0,
        isZhan: false
      }, {
        tit: '媒体类型',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(this.$store.getters.wMediaType)),
        actheight: false,
        act: 0,
        isZhan: false
      }, {
        tit: '应用类型',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(this.$store.getters.wApplicationType)),
        actheight: false,
        act: 0,
        isZhan: true
      }
      // {
      //   tit:'类型',
      //   itemList:[...this.$store.getters.wResourceType],
      //   actheight:false,
      //   act:0,
      //   isZhan:false,
      // },
      ],
      total: 0,
      page: {
        pageNumber: 1,
        pageSize: 12
      },
      titleInfo: {},
      proList: [],
      proListAll: [],
      query: {
        onState: 1,
        pageSize: 8,
        pageNum: 1
      },
      loading: false
    };
  },
  methods: {
    toSsearch: function toSsearch(e) {
      console.log('dianji', e);
      this.query.keyWord = e.courseName;
      this.query.majorName = e.majorName;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(e) {
      // console.log(e, "curr");
      this.query.pageNum = e;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.query.pageSize = e;
      this.query.pageNum = 1;
      this.getList();
    },
    tabs: function tabs(i, j) {
      this.curIndex = j;
      j == 2 ? this.menusList = this.menusList2 : this.menusList = this.menusList1;
      this.query.resourceLibraryType = i.id;
      this.getList();
    },
    chooseList: function chooseList(e) {
      console.log(e);
      if (e[0] == '产业分类') {
        if (e[1].name == '全部') {
          this.query.industry = '';
        } else {
          this.query.industry = e[1].name;
        }
      } else if (e[0] == '行业门类') {
        if (e[1].name == '全部') {
          this.query.industryDetail = '';
        } else {
          this.query.industryDetail = e[1].remark;
        }
      } else if (e[0] == '级别') {
        if (e[1].name == '全部') {
          this.query.majorLevel = '';
        } else {
          this.query.majorLevel = e[1].name;
        }
      } else if (e[0] == '媒体类型') {
        this.query.mediaType = e[1].id;
      } else if (e[0] == '应用类型') {
        this.query.applicationType = e[1].id;
      }
      this.query.pageNum = 1;
      this.getList();
      // console.log('zizujian',e)
    },
    getList: function getList() {
      var _this = this;
      this.loading = true;
      (0, _index2.zyzykList)(this.query).then(function (res) {
        if (res.code == 200) {
          _this.proList = res.rows;
          _this.total = res.total;
          _this.loading = false;
        }
      });
    },
    lookDetail: function lookDetail(res) {
      var url = "https://www.icve.com.cn/portalproject/themes/default/" + res + "/sta_page/index.html?projectId=" + res;
      window.open(url);
    }
  },
  created: function created() {
    // if(this.tabList.length>0){
    //   this.query.resourceLibraryType = this.tabList[0].id
    // }
    this.menusList = this.menusList1;
  },
  mounted: function mounted() {
    this.getList();
  }
};